import dynamicFormElementAttributes from "./lib/dynamicFormElementAttributes";

export default dynamicFormElementAttributes;
